export default __webpack_public_path__ + "static/Q6_3_GiantDog-c65b2b5478c26950773491a1035ec32c.svg";